import { useState } from 'react'
import { useRouter } from 'next/router'
import { useWishlist } from './use-wishlist'
import { UPDATE_WISHLIST } from '../graphql/updateWishlist'
import { graphqlFetch, GraphqlFetchOutput } from '@pylot-data/graphqlFetch'
import {
    MutationUpdateWishlistArgs,
    UpdateWishlistOutput
} from '@pylot-data/pylotschema'

export interface UpdateOutputInterface {
    updateWishlist: UpdateWishlistOutput
}

export interface UseUpdateWishlistInterface {
    isLoading: boolean
    updateWishlist: (
        formInput: MutationUpdateWishlistArgs
    ) => Promise<GraphqlFetchOutput<UpdateOutputInterface>>
}

export const useUpdateWishlist = (): UseUpdateWishlistInterface => {
    const [isLoading, setIsLoading] = useState(false)
    const { locale } = useRouter()
    const { mutate } = useWishlist()

    const updateWishlist = async (formInput: MutationUpdateWishlistArgs) => {
        setIsLoading(true)

        const response = await graphqlFetch<
            MutationUpdateWishlistArgs,
            UpdateOutputInterface
        >({
            query: UPDATE_WISHLIST,
            variables: formInput,
            locale
        })

        await mutate()
        setIsLoading(false)

        return response
    }

    return {
        isLoading,
        updateWishlist
    }
}
